import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=74f120e7&scoped=true&"
import script from "./YesNo.vue?vue&type=script&lang=js&"
export * from "./YesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f120e7",
  null
  
)

export default component.exports